import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import { Item } from '@/models';
import moment from 'moment';

Vue.use(Vuex);
const date = moment(new Date()).subtract(1, 'year').format('YYYY-MM-DD');
export default new Vuex.Store({
  state: {
    user: null,
    isLoading: false,
    loadingMessage: '',
    errorMessage: '',
    ordersAndBookingItems: [],
    itemsInList: [],
    bookedItems: [],
    bookedItemsSearch: [],
    orderBooked: [],
    transportVendors: [],
    auctionVendors: [],
    yardVendors: [],
    ordersCount: 0,
    accessTokenJPC: '',
    isLoadingApi: false,
    listCustomerInf: [],
    handlingCompany:[],
    listIdBooking: []
  },
  mutations: {
    setOrdersCount(state, ordersCount) {
      state.ordersCount = ordersCount;
    },
    setUser(state, user) {
      state.user = user;
    },
    isLoading(state, v) {
      state.isLoading = v;
    },
    isLoadingApi(state, v) {
      state.isLoadingApi = v;
    },
    setLoadingMessage(state, v) {
      state.loadingMessage = v;
    },
    setErrorMessage(state, v) {
      state.errorMessage = v;
    },
    setOrdersAndBookingItems(state, items) {
      state.ordersAndBookingItems = items;
    },
    setBookedItems(state, items) {
      state.bookedItems = items;
    },
    setBookedItemsMore(state, items) {
      items = [...state.bookedItems, ...items]
      state.bookedItems = items;
    },
    setItemsInList(state, items) {
      state.itemsInList = items;
    },
    setTransporVendors(state, vendors) {
      state.transportVendors = vendors;
    },
    setAuctionVendors(state, vendors) {
      state.auctionVendors = vendors;
    },
    setYardVendors(state, vendors) {
      state.yardVendors = vendors.slice().sort((a:any, b:any) => a.AREA_NAME.value.localeCompare(b.AREA_NAME.value));
    },
    setTokenJPC(state, vendors) {
      state.accessTokenJPC = vendors.access_token;
    },
    setCustomerInf(state, resp) {
      state.listCustomerInf = resp.data;
    },
    setHandlingCompany(state, vendors) {
      state.handlingCompany = vendors;
    },
    setListIdBooking(state, items) {
      state.listIdBooking = items;
    },
  },
  getters: {
    incompleteItemCount(_, getters) {
      return getters.incompleteItems.length;
    },
    completedItemCount(_, getters) {
      return getters.completedItems.length;
    },
    incompleteItems(state) {
      return state.ordersAndBookingItems
        .map((item) => new Item(item))
        .filter((item) => item.status == 0 && item.orderDate >= date);
    },
    completedItems(state) {
      return state.ordersAndBookingItems
        .map((item) => new Item(item))
        .filter((item) => item.status == 1 && item.orderDate >= date);
    },
    bookedItems(state) {
      return state.bookedItems.map((item) => new Item(item));
    },
    findItemById(state) {
      return (id: string) => {
        let item: any = state.ordersAndBookingItems.find((item: any) => item.id == id);
        if (!item) {
          item = state.bookedItems.find((item: any) => item.id == id);
          if (!item) {
            item = state.bookedItemsSearch.find((item: any) => item.id == id);
          } 
        } 
        return item && new Item(item);
      };
    },
    nextItemInList(state) {
      return (item: Item) => {
        const k = state.itemsInList.findIndex((o: any) => o.id == item.id) + 1;
        return state.itemsInList[k] ? state.itemsInList[k] : null;
      };
    },
    prevItemInList(state) {
      return (item: Item) => {
        const k = state.itemsInList.findIndex((o: any) => o.id == item.id) - 1;
        return state.itemsInList[k] ? state.itemsInList[k] : null;
      };
    },
    transportVendorsWithItems(_, getters) {
      const map = getters.completedItems.reduce((vendors: any, item: any) => {
        if (!vendors[item.transportVendorId]) {
          vendors[item.transportVendorId] = {
            id: item.transportVendorId,
            name: item.transportVendorName,
            items: [],
          };
        }
        vendors[item.transportVendorId].items.push(new Item(item));
        return vendors;
      }, {});
      return Object.keys(map).map((k) => map[k]);
    },
    auctionVendor(state) {
      return (id: string) =>
        state.auctionVendors.find((v: any) => v.AA_ID.value == id);
    },
    transportVendor(state) {
      return (id: string) =>
        state.transportVendors.find((v: any) => v.TransporterID.value == id);
    },
    transportVendorWithItems(_, getters) {
      return (id: string) => {
        const vendor = getters.transportVendorsWithItems.find(
          (v: any) => v.id == id
        );
        if (vendor) {
          vendor.items.sort((a: any, b: any) => {
            const x = a.transportFromName + a.lotNo;
            const y = b.transportFromName + b.lotNo;
            return x > y ? 1 : -1;
          });
        }
        return vendor;
      };
    },
    yardVendor(state) {
      return (id: string) =>
        state.yardVendors.find((v: any) => v.AREA_NAME.value == id);
    },
    transportVendorsWithCustomer(_, getters) {
      const map = getters.completedItems.reduce((vendors: any, item: any) => {
        if (!vendors[item.customerId]) {
          vendors[item.customerId] = {
            id: item.customerId,
            name: item.customerName,
            items: [],
          };
        }
        vendors[item.customerId].items.push(new Item(item));
        return vendors;
      }, {});
      return Object.keys(map).map((k) => map[k]);
    },
    transportVendorWithCustomer(_, getters) {
      return (id: string) => {
        const vendor = getters.transportVendorsWithCustomer.find(
          (v: any) => v.id == id
        );
        if (vendor) {
          vendor.items.sort((a: any, b: any) => {
            const x = a.transportFromName + a.lotNo;
            const y = b.transportFromName + b.lotNo;
            return x > y ? 1 : -1;
          });
        }
        return vendor;
      };
    },
    customerBooking(state) {
      return (id: string) =>
        state.listCustomerInf.find((v: any) => v.customer_id_format == id);
    },
    getListIdBooking(state){
      return state.listIdBooking;
    }
  },
  actions,
});
